import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { ZiroModalService } from './ziro-modal.service';
import { FileUploadProgressModalComponent } from '../../modals/file-upload-progress-modal/file-upload-progress-modal.component';
import { catchError, filter, map } from 'rxjs/operators';

@Injectable()
export class FileUploadService {
  private _ziroModalService = inject(ZiroModalService);

  upload<T>(fileUploadHttpObservable: Observable<HttpEvent<T>>, uploadMessage: string): Observable<T> {
    const uploadProgress = new Subject<number>();
    this._ziroModalService.openCustomModal(
      FileUploadProgressModalComponent,
      {
        fileUploadProgress: uploadProgress,
        message: uploadMessage,
      },
      { size: 'lg', centered: true },
    );
    return fileUploadHttpObservable.pipe(
      filter((event) => {
        return this._listenToUploadProgress(event, uploadProgress);
      }),
      map((event) => {
        return event.type === HttpEventType.Response && event.body;
      }),
      catchError((err) => {
        uploadProgress.complete();
        throw err;
      }),
    );
  }

  private _listenToUploadProgress<T>(event: HttpEvent<T>, listener: Subject<number>): boolean {
    if (!event) {
      return false;
    }
    switch (event.type) {
      case HttpEventType.UploadProgress:
        listener.next(event.total ? Math.round((event.loaded / event.total) * 95) : 0);
        return false;
      case HttpEventType.Response:
        listener.next(100);
        listener.complete();
        return true;
    }
  }
}
